export type NavGate = "classes" | "dashboard" | "school" | "student";

export type NavGateState = Record<NavGate, boolean>;

export const NAV_GATES: NavGate[] = ["classes", "dashboard", "school", "student"];

export const NAV_GATE_STORAGE_KEY = "signpost-nav-gates";

export const NAV_GATE_ATTRS: Record<NavGate, string> = {
    classes: "data-nav-classes",
    dashboard: "data-nav-dashboard",
    school: "data-nav-school",
    student: "data-nav-student",
};

const EMPTY: NavGateState = { classes: false, dashboard: false, school: false, student: false };

export const NAV_GATE_BOOTSTRAP = `
(function() {
  try {
    var raw = localStorage.getItem('${NAV_GATE_STORAGE_KEY}');
    if (!raw) return;
    var gates = JSON.parse(raw);
    if (!gates) return;
    var el = document.documentElement;
${NAV_GATES.map(
    (gate) =>
        `    if (gates.${gate}) el.setAttribute('${NAV_GATE_ATTRS[gate]}', '1');`,
).join("\n")}
  } catch (e) {}
})();
`;

export function readNavGates(): NavGateState {
    if (typeof window === "undefined") return { ...EMPTY };
    try {
        const raw = window.localStorage.getItem(NAV_GATE_STORAGE_KEY);
        if (!raw) return { ...EMPTY };
        const parsed = JSON.parse(raw) as Partial<NavGateState> | null;
        if (!parsed || typeof parsed !== "object") return { ...EMPTY };
        return {
            classes: Boolean(parsed.classes),
            dashboard: Boolean(parsed.dashboard),
            school: Boolean(parsed.school),
            student: Boolean(parsed.student),
        };
    } catch {
        return { ...EMPTY };
    }
}

export function applyNavGates(next: Partial<NavGateState>): void {
    if (typeof window === "undefined") return;
    const merged = { ...readNavGates(), ...next };
    try {
        window.localStorage.setItem(
            NAV_GATE_STORAGE_KEY,
            JSON.stringify(merged),
        );
    } catch {}
    const el = document.documentElement;
    for (const gate of NAV_GATES) {
        if (merged[gate]) el.setAttribute(NAV_GATE_ATTRS[gate], "1");
        else el.removeAttribute(NAV_GATE_ATTRS[gate]);
    }
}
